"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        // Ver o comentario em `accounting-dre.routes.js`: periodo em query, como na empresa.
        .state("nucont.accounting.group.demonstrations.accounting.balance", {
            url: "/balanco?date&view&scenarioId",
            views: {
                "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                    component: "accountingBalanceComponent",
                    bindings: { companyData: "groupData" }
                }
            },
            params: {
                demonstration: { value: "balanco", dynamic: false },
                date: { value: null, dynamic: true },
                view: { value: null, dynamic: true },
                scenarioId: { value: null, dynamic: true },
                stateIndentifier: { value: "balance" }
            },
            bodyClass: "balance-module"
        })
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.showtime",
            {
                url: "/showtime",
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.comparation",
            {
                url:
                    "/comparacao?date&month&comparationView&comparationDate&analysisVertical&analysisHorizontal",
                views: {
                    "demonstrationAccountingView@nucont.accounting.group.demonstrations.accounting": {
                        component: "accountingBalanceComparationComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                params: {
                    date: { value: null, dynamic: true },
                    month: { value: null, dynamic: true },
                    comparationView: { value: null, dynamic: true },
                    comparationDate: { value: null, dynamic: true },
                    stateIndentifier: { value: "balance.comparation" },
                    analysisVertical: { value: null, dynamic: true },
                    analysisHorizontal: { value: null, dynamic: true }
                },
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.comparation.showtime",
            {
                url: "/showtime",
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.comparation.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance.comparation": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.comparation.showtime.comments",
            {
                url: "/comentarios",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance.comparation": {
                        component: "indicatorCommentsComponent",
                        bindings: { companyData: "groupData" }
                    }
                },
                bodyClass: "balance-module"
            }
        )
        .state(
            "nucont.accounting.group.demonstrations.accounting.balance.comparation.showtime.insights",
            {
                url: "/insights",
                views: {
                    "subModule@nucont.accounting.group.demonstrations.accounting.balance.comparation": {
                        component: "indicatorInsightsComponent"
                    }
                },
                bodyClass: "balance-module"
            }
        );
}
